import React, { useEffect, useState } from "react";
//import JumboDemoCard from "@jumbo/components/JumboDemoCard";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Autocomplete,
  TextField,
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { dispatch } from "app/store/store";
import {
  showHideSwitchAccountModal,
  switchToAccount,
} from "app/store/slice/common-slice";
/***Temp Files** */
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { useTheme } from "@mui/material";
//import code from "../Dialogs/demo-code/alert-dialog.txt";
//import Div from "@jumbo/shared/Div";

const AlertDialog = (props) => {
  const Swal = useSwalWrapper();
  const theme = useTheme();
  const sweetAlerts = (variant, message) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      //   onOpen: (toast) => {
      //     toast.addEventListener("mouseenter", Swal.stopTimer);
      //     toast.addEventListener("mouseleave", Swal.resumeTimer);
      //   },
    });

    Toast.fire({
      icon: variant,
      title: message,
      background: theme.palette.background.paper,
    });
  };

  const { openSwitchAccountModal, globalAccount, globalAccountsList } =
    useSelector((state) => state.CommonReducer);

  const getAccountName = () => {
    let obj = globalAccountsList.find((o) => o.value == globalAccount);
    if (obj) {
      return obj;
    } else {
      return "";
    }
  };
  const [account, setAccount] = React.useState("");
  useEffect(() => {
    setAccount(getAccountName());
  }, [globalAccountsList, globalAccount]);
  const changeSwitchAccountHandler = (value) => {
    setAccount(value);
  };

  const switchAccountHandler = () => {
    dispatch(switchToAccount(account));
    sweetAlerts("info", "Now viewing " + account.label);
  };
  const closeModal = () => {
    dispatch(showHideSwitchAccountModal(false));
    setAccount(getAccountName());
  };
  return (
    <div>
      <Dialog
        open={openSwitchAccountModal}
        //onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        //sx={{ borderRadius: "15px" }}
        sx={{
          "& .css-nubafe-MuiPaper-root-MuiDialog-paper": {
            borderRadius: "15px",
          },
        }}
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle> */}
        <DialogContent
          sx={{
            width: { xs: "290px", sm: "400px", md: "400px", lg: "400px" },
            pt: "40px",
            pb: "20px",
          }}
        >
          {/* <FormControl sx={{ width: "100%" }}> */}

          <Box>
            <Autocomplete
              clearOnEscape
              disableClearable
              id="global_account_id"
              options={globalAccountsList}
              sx={{
                width: "100%",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Switch Account"
                  placeholder="Accounts"
                  // variant="standard"
                />
              )}
              onChange={(event, value) => changeSwitchAccountHandler(value)}
              value={account}
            />
          </Box>

          {/* </FormControl> */}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: "30px" }}>
          <Button
            onClick={closeModal}
            variant="outlined"
            color="error"
            size="small"
          >
            Cancel
          </Button>
          <Button
            onClick={switchAccountHandler}
            //autoFocus
            variant="contained"
            color="success"
            size="small"
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertDialog;
